import React, { useEffect, useState } from 'react';

const weightOptions = [
  150, 155, 160, 165, 170, 175, 180, 185, 190, 195, 200, 205
];

const StepWeight = ({ data, setData, onNext, onPrev }) => {
  const [customWeight, setCustomWeight] = useState('');

  const handleSelect = (weight) => {
    setData(prev => ({
      ...prev,
      weight: `${weight} lbs`
    }));
    setCustomWeight('');
  };

  const handleCustomChange = () => {
    if (customWeight) {
      setData(prev => ({
        ...prev,
        weight: `${customWeight} lbs`
      }));
    }
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      weight: null
    }));
    onNext();
  };

  // ✅ Pre-fill custom weight if it's not in the options
  useEffect(() => {
    const match = data.weight?.match(/^(\d+)\s*lbs$/);
    const parsed = match ? parseInt(match[1]) : '';
    if (parsed && !weightOptions.includes(parsed)) {
      setCustomWeight(parsed);
    }
  }, [data.weight]);

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="weight-container">
              <h2 className="selection-title">How much do you weigh?</h2>

              <div className="weight-options selection-grid">
                {weightOptions.map((w) => (
                  <button
                    key={w}
                    className={`selection-btn ${data.weight === `${w} lbs` ? 'active' : ''}`}
                    onClick={() => handleSelect(w)}
                  >
                    {w} lbs
                  </button>
                ))}
              </div>

              <div className="custom-height mt-3">
                <label>Something else:</label>
                <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                  <input
                    type="text"
                    placeholder="lbs"
                    value={customWeight}
                    onChange={(e) => setCustomWeight(e.target.value)}
                    onBlur={handleCustomChange}
                  />
                </div>
              </div>

              <button className="skip-btn mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="nav-buttons mt-4">
                <button className="selection-prev-btn" onClick={onPrev}>
                  Prev
                </button>
                <button
                  className="selection-next-btn"
                  onClick={onNext}
                  disabled={!data.weight}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepWeight;
